import { render, staticRenderFns } from "./collector.vue?vue&type=template&id=6af1a0bc"
import script from "./collector.vue?vue&type=script&lang=js"
export * from "./collector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports